import { Component, inject } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-rejected-request',
  templateUrl: './modal-rejected-request.component.html',
  styleUrls: ['./modal-rejected-request.component.css']
})
export class ModalRejectedRequestComponent {
  private readonly _modalRef: NzModalRef = inject(NzModalRef);
  motivation: string = '';

  constructor() {}

  closeModal() {
    this._modalRef.close();
  }

  confirm() {
    this._modalRef.close(this.motivation);
  }
}
